import styled from 'foundations-theming-specialty/utils';

// --- DefaultAgentIcon Component ---
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFlex = styled.div.withConfig({
  displayName: "DefaultAgentIcon__StyledFlex",
  componentId: "xxx8km-0"
})(["display:flex;align-items:center;justify-content:center;border-radius:", ";background-color:", ";block-size:", ";inline-size:", ";margin-block-end:", ";min-block-size:", ";min-inline-size:", ";position:relative;"], ({
  theme,
  rounded
}) => rounded ? theme.borderRadius['breeze-core-component-default'] : theme.borderRadius['100'], props => props.background === 'gradient' ? props.theme.color['breeze-fill-secondary-hover'] : 'transparent', props => props.background === 'gradient' ? props.size : 'auto', props => props.size, ({
  theme,
  marginBlockEnd
}) => {
  const spaceKey = marginBlockEnd || '400';
  return theme.space[spaceKey];
}, props => props.background === 'gradient' ? props.size : '14px', props => props.size);
const BreezeSingleStar = ({
  size
}) => {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 26 26",
    fill: "none",
    children: [/*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0_2633_15910)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M24.8043 12.2195C18.7896 12.2195 13.7629 7.02485 13.7629 0.798482C13.7629 0.36784 13.4163 0.00897217 13.0003 0.00897217C12.5843 0.00897217 12.2376 0.36784 12.2376 0.798482C12.2376 7.02485 7.21093 12.2195 1.19626 12.2195C0.771594 12.2195 0.433594 12.5783 0.433594 13.009C0.433594 13.4486 0.771594 13.7985 1.19626 13.7985C7.21093 13.7985 12.2376 18.9931 12.2376 25.2195C12.2376 25.6501 12.5843 26.009 13.0003 26.009C13.4163 26.009 13.7629 25.6501 13.7629 25.2195C13.7629 18.9931 18.7896 13.7985 24.8043 13.7985C25.2289 13.7985 25.5669 13.4396 25.5669 13.009C25.5669 12.5694 25.2289 12.2195 24.8043 12.2195Z",
        fill: "url(#paint0_linear_2633_15910)"
      })
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_2633_15910",
        x1: "-2.42711",
        y1: "13.009",
        x2: "26.1031",
        y2: "25.4092",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0.0337066",
          stopColor: "#FC0849"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.970647",
          stopColor: "#D20688"
        })]
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_2633_15910",
        children: /*#__PURE__*/_jsx("rect", {
          width: "26",
          height: "26",
          fill: "white"
        })
      })]
    })]
  });
};
export const DefaultAgentIcon = ({
  marginBlockEnd,
  size,
  background = 'gradient',
  rounded = false
}) => {
  const numericalSize = size || 48;
  const containerSize = `${numericalSize}px`;
  return /*#__PURE__*/_jsx(StyledFlex, {
    size: containerSize,
    marginBlockEnd: marginBlockEnd,
    background: background,
    rounded: rounded,
    children: /*#__PURE__*/_jsx(BreezeSingleStar, {
      size: "60%"
    })
  });
};